import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { games as gamesApi } from "../lib/api";
import GameBoard from "../components/GameBoard";

export default function PublicGamePage() {
  const { token } = useParams();
  const { t } = useTranslation();
  const [game, setGame] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    gamesApi.publicGame(token).then(setGame).catch(() => setErr(true));
  }, [token]);

  if (err) {
    return (
      <div className="min-h-screen bg-[#0A1329] text-white grid place-items-center px-6 text-center" data-testid="public-game-not-available">
        {t("games.not_available")}
      </div>
    );
  }
  if (!game) {
    return <div className="min-h-screen bg-[#0A1329] text-white grid place-items-center">{t("common.loading")}</div>;
  }
  return <GameBoard game={game} canSave={false} />;
}
